/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ClientCountDto } from '../model/clientCountDto';
import { ClientDto } from '../model/clientDto';
import { ClientDtos } from '../model/clientDtos';
import { Clients } from '../model/clients';
import { CreateApiKeyDto } from '../model/createApiKeyDto';
import { ProblemDetails } from '../model/problemDetails';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ClientService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientCreateClientPost(body?: ClientDto, observe?: 'body', reportProgress?: boolean): Observable<ClientDtos>;
    public apiClientCreateClientPost(body?: ClientDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientDtos>>;
    public apiClientCreateClientPost(body?: ClientDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientDtos>>;
    public apiClientCreateClientPost(body?: ClientDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ClientDtos>('post',`${this.basePath}/api/Client/CreateClient`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientGetAllClientsDropDownGet(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiClientGetAllClientsDropDownGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiClientGetAllClientsDropDownGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiClientGetAllClientsDropDownGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/Client/GetAllClientsDropDown`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientGetAllClientsGet(skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<ClientCountDto>;
    public apiClientGetAllClientsGet(skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientCountDto>>;
    public apiClientGetAllClientsGet(skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientCountDto>>;
    public apiClientGetAllClientsGet(skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientCountDto>('get',`${this.basePath}/api/Client/GetAllClients`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param accountEmail 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientGetClientByAccountEmailGet(accountEmail?: string, observe?: 'body', reportProgress?: boolean): Observable<Clients>;
    public apiClientGetClientByAccountEmailGet(accountEmail?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Clients>>;
    public apiClientGetClientByAccountEmailGet(accountEmail?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Clients>>;
    public apiClientGetClientByAccountEmailGet(accountEmail?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (accountEmail !== undefined && accountEmail !== null) {
            queryParameters = queryParameters.set('accountEmail', <any>accountEmail);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Clients>('get',`${this.basePath}/api/Client/GetClientByAccountEmail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param authId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientGetClientByAuthIdGet(authId?: string, observe?: 'body', reportProgress?: boolean): Observable<ClientDtos>;
    public apiClientGetClientByAuthIdGet(authId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientDtos>>;
    public apiClientGetClientByAuthIdGet(authId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientDtos>>;
    public apiClientGetClientByAuthIdGet(authId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (authId !== undefined && authId !== null) {
            queryParameters = queryParameters.set('authId', <any>authId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientDtos>('get',`${this.basePath}/api/Client/GetClientByAuthId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param Id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientGetClientByIdGet(Id?: string, observe?: 'body', reportProgress?: boolean): Observable<ClientDtos>;
    public apiClientGetClientByIdGet(Id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientDtos>>;
    public apiClientGetClientByIdGet(Id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientDtos>>;
    public apiClientGetClientByIdGet(Id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Id !== undefined && Id !== null) {
            queryParameters = queryParameters.set('Id', <any>Id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientDtos>('get',`${this.basePath}/api/Client/GetClientById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientGetClientByNameGet(name?: string, observe?: 'body', reportProgress?: boolean): Observable<ClientDtos>;
    public apiClientGetClientByNameGet(name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientDtos>>;
    public apiClientGetClientByNameGet(name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientDtos>>;
    public apiClientGetClientByNameGet(name?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientDtos>('get',`${this.basePath}/api/Client/GetClientByName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param skip 
     * @param take 
     * @param search 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientGetGet(skip?: number, take?: number, search?: string, observe?: 'body', reportProgress?: boolean): Observable<ClientCountDto>;
    public apiClientGetGet(skip?: number, take?: number, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientCountDto>>;
    public apiClientGetGet(skip?: number, take?: number, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientCountDto>>;
    public apiClientGetGet(skip?: number, take?: number, search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientCountDto>('get',`${this.basePath}/api/Client/Get`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientInsertClientApiKeyPost(body?: CreateApiKeyDto, observe?: 'body', reportProgress?: boolean): Observable<ClientDtos>;
    public apiClientInsertClientApiKeyPost(body?: CreateApiKeyDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientDtos>>;
    public apiClientInsertClientApiKeyPost(body?: CreateApiKeyDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientDtos>>;
    public apiClientInsertClientApiKeyPost(body?: CreateApiKeyDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ClientDtos>('post',`${this.basePath}/api/Client/InsertClientApiKey`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
